// removed by extract-text-webpack-plugin
module.exports = {"event-group-page":"_3xgXKM7Qf _30W7J4cYZ gkmejKHip"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/event-group-page/event-group-page.css
 ** module id = 2190
 ** module chunks = 0
 **/